import * as Yup from 'yup';

import CertificateIcon from 'components/icons/CertificateIcon';
import LockerIcon from 'components/icons/LockerIcon';
import MedalIcon from 'components/icons/MedalIcon';
import PhoneCallIcon from 'components/icons/PhoneCallIcon';
import SearchIcon from 'components/icons/SearchIcon';
import TrophyIcon from 'components/icons/TrophyIcon';
import WingShieldIcon from 'components/icons/WingsShieldIcon';
import WorkerIcon from 'components/icons/WorkerIcon';

import CheckCircleIcon from 'components/icons/CheckCircleIcon';
import ErrorIcon from 'components/icons/ErrorIcon';
import parsePhoneNumberFromString from 'libphonenumber-js';

const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

export const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .test('is-valid-phone', 'Phone number is not valid', function (value) {
      const countrySymbol = 'US';
      if (!value || !countrySymbol || value.length < 7) return false;
      const phoneNumber = parsePhoneNumberFromString(value, countrySymbol);
      return phoneNumber && phoneNumber.isPossible() && phoneNumber.isValid();
    }),
});

export const badgesContent = [
  {
    icon: <WingShieldIcon w="4rem" h="4rem" />,
    title: 'Rental Expert',
  },
  {
    icon: <MedalIcon w="4rem" h="4rem" />,
    title: 'Customer Trust',
  },
  {
    icon: <CertificateIcon w="4rem" h="4rem" />,
    title: 'Enterprising Starter',
  },
  {
    icon: <TrophyIcon w="4rem" h="4rem" />,
    title: 'Efficient Manager',
  },
];

export const securityContent = [
  {
    icon: <LockerIcon w="4rem" h="4rem" />,
    title: `2-Step Verification`,
  },
  {
    icon: <SearchIcon w="4rem" h="4rem" />,
    title: `Recovery Email`,
  },
  {
    icon: <PhoneCallIcon w="4rem" h="4rem" />,
    title: `Recovery Phone`,
  },
  {
    icon: <WorkerIcon w="4rem" h="4rem" />,
    title: `Confirmed indentity`,
  },
];

export const stripeInfoContent = [
  {
    title: 'Strippe Connect',
    text: 'You need to connect Stripe so we can send you payments, please click the button and set up Stripe',
    icon: () => <ErrorIcon />,
    buttonText: 'Connect Stripe Account',
  },
  {
    title: 'Strippe Connect',
    text: 'You need to connect Stripe so we can send you payments, please click the button and set up Stripe',
    icon: () => <CheckCircleIcon />,
    buttonText: 'Configure Stripe Account',
  },
];
